
import { Component, Vue, Ref } from 'vue-property-decorator'
import { MediaService } from '@/services/index'
import TableHeader from '@/components/table_header/index.vue'
import FullLoading from '@/components/full_loading/index.vue'
import ScrollTo from '@/components/scroll_to/index.vue'
import ScrollToType from '@/components/scroll_to/type'

@Component({
    name: 'MediaRelations',
    components: {
        TableHeader,
        FullLoading,
        ScrollTo
    }
})
export default class extends Vue {
    @Ref('scrollRef') private scrollEl!: ScrollToType
    private relations = []
    private pageIndex = 1
    private pageSize = 50
    private pageTotal = 0
    private tableHeaderDecs = ''
    private searchQuery = ''
    private loading = true 
    private fetchLoading = false
    private searchTip = ''
    
    mounted() {
        this.getRelations()
    }

    async getRelations() {
        const params = {
            query: this.searchQuery,
            page_index: this.pageIndex, 
            page_size: this.pageSize 
        }
        const result = await MediaService.getRelations(params)
        if (result.status === 200) {
            this.pageTotal = result.data.page_total
            this.relations = result.data.rel_list
            this.tableHeaderDecs = '一共有 ' + this.pageTotal + ' 家'
            this.updateSearchTip()
        }
        this.loading = false
    }
    private updateSearchTip() {
        if (!this.searchQuery.trim()) {
            this.searchTip = ''
            return
        }

        const relList = this.relations || []
        const mediumOrgValues = new Set<number>()

        relList.forEach((item: any) => {
            const orgType = item.MediumOrg
            if (orgType !== undefined && orgType !== null) {
                mediumOrgValues.add(orgType)
            }
        })

        const values = Array.from(mediumOrgValues)

        if (values.length === 0) {
            this.searchTip = ''
        } else if (values.length === 1) {
            if (values[0] === 1 || values[0] === 3) {
                this.searchTip = '您搜索的为主媒体'
            } else if (values[0] === 2) {
                this.searchTip = '您搜索的为子媒体'
            } else if (values[0] === 0) {
                this.searchTip = '您的搜索无结果'
            } else {
                this.searchTip = ''
            }
        } else if (values.length >= 2) {
            const has1 = values.includes(1)
            const has2 = values.includes(2)
            const has3 = values.includes(3)

            if ((has1 && has2) || (has1 && has3) || (has2 && has3)) {
                this.searchTip = '您搜索的有主媒体和子媒体'
            } else {
                this.searchTip = ''
            }
        } else {
            this.searchTip = ''
        }
    }
    onCurrentChange(page: any) {
        this.pageIndex = page
        this.scrollEl.scrollToTop(this.getRelations)
    }

    onCreate() {
        this.$router.push({ name: 'MediaRelationCreate' })
    }

    onEdit(data: any) {
        window.open('/media/relation/' + data.id + '/edit')
    }

    async onSearchMedia() {
        this.pageIndex = 1
        this.pageTotal = 0
        this.fetchLoading = true
        await this.getRelations()
        this.fetchLoading = false
    }
}
